// src/components/RefundManager/components/BankRefund/BankRefund.tsx
import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getLocalCajaManagement } from '../../../../../../../../../../../../crud/management_api/locales_caja_management';
import '../CashRefund/CashRefund.scss';
import SearchDropdown from '../../../../../../../../../../../../components/common/SearchDropdown/SearchDropdown';

interface BankRefundProps {
  receipt: any;
  setPayload: (payload: any) => void;
  setIsDisabled: (disabled: boolean) => void;
}

const BankRefund: React.FC<BankRefundProps> = ({
  receipt,
  setPayload,
  setIsDisabled, 
}) => {
  const movementAmount = receipt?.total_payed || 0;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const localId = Number(user.local_id) || 0;
  const userId = Number(user.user_id) || 0;

  const [customDescriptionData, setCustomDescriptionData] = useState({
    name: '',
    idNumber: '',
    email: '',
    bankName: '',
    accountType: '',
    accountNumber: '',
    amount: movementAmount,
  });
  const [workstations, setWorkstations] = useState<
    { workstation_id: number; workstation_name: string }[]
  >([]);
  const [selectedWs, setSelectedWs] = useState<number | null>(null);
  
  const handleInputChange = (
    field: keyof typeof customDescriptionData,
    value: string
  ) => {
    setCustomDescriptionData(prev => ({
      ...prev,
      [field]: field === 'amount' ? Number(value) : value,
    }));
  };

  useEffect(() => {
    getLocalCajaManagement(localId, userId)
      .then(res => {
        const openCajas = res.data
          .filter((ws: any) => ws.is_open)
          .map((ws: any) => ({
            workstation_id: ws.workstation_id,
            workstation_name: ws.workstation_name,
            is_open: ws.is_open,
          }));
        setWorkstations(openCajas);
        if (openCajas.length > 0) {
          setSelectedWs(openCajas[0].workstation_id);
        }
      })
      .catch(err => console.error('Error fetching cajas:', err));
  }, [localId, userId]);

  // 2) Cada vez que cambie cualquier campo o la caja seleccionada, reconstruyo el payload
  useEffect(() => {
    // Si no hay caja, deshabilito y no emito
    if (selectedWs === null) {
      setIsDisabled(true);
      return;
    }

    const payload = {
      refundType: 2,
      workstationId: selectedWs,
      description: {
        name: customDescriptionData.name,
        idNumber: customDescriptionData.idNumber,
        email: customDescriptionData.email,
        bankName: customDescriptionData.bankName,
        accountType: customDescriptionData.accountType,
        accountNumber: customDescriptionData.accountNumber,
        amount: customDescriptionData.amount,
      },
    };

    setPayload(payload);

    // Y habilito/deshabilito el botón según si el formulario está completo
    const formValid =
      customDescriptionData.name.trim() !== '' &&
      customDescriptionData.idNumber.trim() !== '' &&
      customDescriptionData.email.trim() !== '' &&
      customDescriptionData.bankName.trim() !== '' &&
      customDescriptionData.accountType.trim() !== '' &&
      customDescriptionData.accountNumber.trim() !== '';
    setIsDisabled(!formValid);
  }, [customDescriptionData, selectedWs, setPayload, setIsDisabled]);

  
  return (
    <Form>
      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Estación para transferencia</Form.Label>
        <SearchDropdown
          items={workstations}
          selected={workstations.find(ws => ws.workstation_id === selectedWs) ?? null}
          setSelected={ws => setSelectedWs(ws ? ws.workstation_id : null)}
          displayProperty="workstation_name"
          idProperty="workstation_id"
          placeholder="Seleccione una caja"
        />
      </Form.Group>
      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Nombre cliente</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingrese el nombre"
          value={customDescriptionData.name}
          onChange={e => handleInputChange('name', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Rut</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingrese la cédula"
          value={customDescriptionData.idNumber}
          onChange={e => handleInputChange('idNumber', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Correo electrónico</Form.Label>
        <Form.Control
          type="email"
          placeholder="Ingrese el correo electrónico"
          value={customDescriptionData.email}
          onChange={e => handleInputChange('email', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Banco</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingrese el nombre del banco"
          value={customDescriptionData.bankName}
          onChange={e => handleInputChange('bankName', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Tipo de cuenta</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingrese el tipo de cuenta"
          value={customDescriptionData.accountType}
          onChange={e => handleInputChange('accountType', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Número de cuenta</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingrese el número de cuenta"
          value={customDescriptionData.accountNumber}
          onChange={e => handleInputChange('accountNumber', e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mp-formgroup horizontal">
        <Form.Label>Monto solicitado</Form.Label>
        <Form.Control
          type="number"
          placeholder="Ingrese el monto solicitado"
          disabled
          value={customDescriptionData.amount}
          onChange={e => handleInputChange('amount', e.target.value)}
        />
      </Form.Group>
    </Form>
  );
};

export default BankRefund;
